<template>
  <footer v-if="$beet.options.footer" class="footer">
    <section class="footer__top">
      <h4 class="footer__legend">{{ $t('company_name') }}</h4>

      <div class="row">
        <address>
          {{
            `${$beet.options.businessInfos.addressLine1}\n${$beet.options.businessInfos.addressLine2}`
          }}
        </address>

        <div>
          <a :href="`mailto:${$beet.options.businessInfos.email}`">{{
            $beet.options.businessInfos.email
          }}</a>
          <p>{{ $beet.options.businessInfos.phoneNumber }}</p>
        </div>

        <nav class="footer__social">
          <a
            v-for="(social, key) in $beet.options.socials"
            :key="key"
            :href="social"
            target="_blank"
            rel="noopener"
            class="footer__icon"
          >
            <Icon v-if="social" :id="key" />
          </a>
        </nav>
      </div>
      <div v-if="$beet.options.footer?.sites?.length">
        <h4 class="footer__legend -top">{{ $t('other_sites') }}</h4>
        <nav class="footer__sites">
          <a
            v-for="site in $beet.options.footer.sites"
            :key="site.flexKey"
            :href="site.url"
            target="_blank"
            >{{ site.label }}</a
          >
        </nav>
      </div>
    </section>

    <section class="footer__bottom row -spread">
      <p>{{ $t('credits').replace(':YEAR', new Date().getFullYear().toString()) }}</p>

      <nav class="footer__links">
        <a :href="$beet.options.footer.compliance" target="_blank" class="footer__legal">{{
          $t('compliance_label')
        }}</a>
        <LangRouterLink
          v-for="key in $store.state.navigation.policies"
          :key="`link-${key}`"
          :to="{ name: key }"
          class="footer__legal"
          >{{ $t(`policies.${key}`) }}
        </LangRouterLink>
      </nav>
    </section>
  </footer>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'SiteFooter',
  components: { Icon, LangRouterLink },
}
</script>
